import {
  FormControl,
  Grid,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
} from '@mui/material'
import React from 'react'

const AccessSuccess = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Successful</InputLabel>
      <Select
        value={moduleValues?.['Successful'] ?? ''}
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Successful']: e.target.value,
          }))
        }
        label="Successful"
      >
        <MenuItem value="Yes">Yes</MenuItem>
        <MenuItem value="No">No</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

export default AccessSuccess
